import {
  required,
  minLength,
} from 'vuelidate/lib/validators';
import { forcePasswordPolicy } from '@/app/utils/validations/validations';
import ConfirmCode from '@/app/modules/auth/components/confirm-code/confirm-code.vue';

export default {
  name: 'forgot-password',
  components: {
    ConfirmCode,
  },
  data: () => ({
    form: {
      username: '',
    },
    accountConfirmCode: '',
    hasInactiveAccount: false,
    hasConfirmCode: false,
    confirmForm: {
      confirmCode: '',
      newPassword: '',
    },
  }),
  methods: {
    formattedUsername() {
      let { username } = this.form;
      if (username.includes('@')) {
        username = this.form.username.toLowerCase();
      }
      return username;
    },
    async handleConfirmCodeClick(value) {
      if (value === 'cancel') {
        this.hasConfirmCode = false;
      } else if (value === 'submit') {
        this.$v.confirmForm.$touch();
        if (!this.$v.confirmForm.$anyError) {
          try {
            await this.$store.dispatch('auth/resetPassword', {
              username: this.formattedUsername(),
              confirmCode: this.confirmForm.confirmCode,
              newPassword: this.confirmForm.newPassword,
            });
            this.$mixpanel.track('resetPassword', {
              usernameOrEmail: this.formattedUsername(),
            });
            this.$router.push('/auth/sign-in');
          } catch (err) {
            console.log(err);
          }
        }
      }
    },
    async handleClick(value) {
      if (value === 'cancel') {
        this.hasInactiveAccount = false;
      } else if (value === 'submit') {
        try {
          await this.$store.dispatch('auth/confirmSignUp', {
            username: this.formattedUsername(),
            code: this.accountConfirmCode.toString(),
          });
          this.hasInactiveAccount = false;
        } catch (err) {
          console.log(err);
        }
      }
    },
    async resetPassword() {
      this.$v.form.$touch();
      if (!this.$v.form.$anyError) {
        try {
          await this.$store.dispatch('auth/forgotPassword', { username: this.formattedUsername() });
          this.$mixpanel.track('forgotPassword', {
            usernameOrEmail: this.formattedUsername(),
          });
          if (this.$store.getters['auth/hasError']) {
            this.hasInactiveAccount = true;
          } else {
            this.hasConfirmCode = true;
          }
        } catch (err) {
          console.log(err);
        }
      }
    },
  },
  validations: {
    form: {
      username: {
        required,
      },
    },
    confirmForm: {
      newPassword: {
        required,
        minLength: minLength(8),
        forcePasswordPolicy,
      },
    },
  },
};
